/** KAN-755: таблица групп товаров: название, описание, товаров; правка только при canEdit. */
import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { ProductGroup } from '@/types/discount';

interface ProductGroupsTableProps {
  items: ProductGroup[];
  canEdit: boolean;
  onEdit: (group: ProductGroup) => void;
  onDelete: (group: ProductGroup) => void;
}

export function ProductGroupsTable({ items, canEdit, onEdit, onDelete }: ProductGroupsTableProps) {
  return (
    <div className="overflow-x-auto rounded-lg border bg-white">
      <Table aria-label="Группы товаров" data-testid="groups-table">
        <TableHeader>
          <TableRow>
            <TableHead>Название</TableHead>
            <TableHead>Описание</TableHead>
            <TableHead className="text-right">Товаров</TableHead>
            {canEdit && <TableHead className="w-24" />}
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((group) => (
            <TableRow key={group.id} data-testid={`group-row-${group.id}`}>
              <TableCell className="min-w-[160px] font-medium">{group.name}</TableCell>
              <TableCell className="min-w-[200px] text-sm text-gray-700">{group.description || '-'}</TableCell>
              <TableCell className="text-right text-sm tabular-nums">{group.products_count}</TableCell>
              {canEdit && (
                <TableCell className="whitespace-nowrap text-right">
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    aria-label={`Изменить: ${group.name}`}
                    onClick={() => onEdit(group)}
                  >
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    aria-label={`Удалить: ${group.name}`}
                    onClick={() => onDelete(group)}
                  >
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </Button>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
